var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 text-center col-md-2 pt-5 pb-5"},[_c('img',{attrs:{"src":require("@/assets/logo_univision 2.png"),"alt":"","width":"100%"}})])])])])
}]

export { render, staticRenderFns }